import React from 'react';
import ReactDOM from 'react-dom';
import App from './client/App';
import {BrowserRouter} from 'react-router-dom';
import {HelmetProvider} from 'rnd-helmet';
import {CookiesProvider} from 'react-cookie';
import {loadableReady} from '@loadable/component';

const supportedLanguages = [];
// Load the routes for the specific country.
const routes = require(`./config/client.routes.json`);
// Iterate through all supported languages for the country.
for (const lang in routes) {
  if (routes.hasOwnProperty(lang)) {
    supportedLanguages.push(lang);
  }
}

let currentLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE;
// Get the current language based on the URL.
const pathname = window.location.pathname;
supportedLanguages.forEach((lang) => {
  if (pathname.startsWith(`/${lang}/`)) {
    currentLanguage = lang;
  }
});

const bootstrap =
  <HelmetProvider>
    <BrowserRouter>
      <CookiesProvider>
        <App
          currentLanguage={currentLanguage}
          links={{
            items: window.myRandstadMenuItem ? [...(window.__LINKS__?.[currentLanguage]?.main || []), window.myRandstadMenuItem] : (window.__LINKS__?.[currentLanguage]?.main || []),
            utilityItems: window.__LINKS__?.[currentLanguage]?.utility,
          }}
          isEnableRelNavigation={window.isEnableRelNavigation}
        />
      </CookiesProvider>
    </BrowserRouter>
  </HelmetProvider>;

if (process.env.REACT_APP_ISDEV) {
  ReactDOM.hydrate(
      bootstrap,
      document.getElementById('root'),
  );
} else {
  loadableReady(() => {
    ReactDOM.hydrate(
        bootstrap,
        document.getElementById('root'),
    );
  });
}
